const W=320,H=420;
const wrap=(n:number):number=>((n%8)+8)%8;
/** Original illustrated views. Never dissolve the character or substitute game meshes. */
export function initOperatorTurntables():void {
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const assets=new Map<string,Promise<HTMLImageElement[]>>();
 const previews=new Map<HTMLImageElement,{canvas:HTMLCanvasElement;angle:number;design:string;views?:HTMLImageElement[];loading?:boolean;hover:boolean;playing:boolean;paused:boolean;drawKey?:string}>();
 const get=(image:HTMLImageElement)=>{
  let state=previews.get(image);
  if(!state){const canvas=document.createElement('canvas');canvas.width=W;canvas.height=H;canvas.className='momo-turntable-canvas';canvas.setAttribute('aria-hidden','true');image.after(canvas);state={canvas,angle:0,design:'',hover:false,playing:false,paused:false};previews.set(image,state);}
  const design=image.dataset.turntable!;
  if(state.design!==design){
   state.design=design;state.angle=0;state.drawKey=undefined;image.style.opacity='';state.canvas.style.display='none';
   state.views=undefined;state.loading=false;
  }
  return state;
 };
 const target=(e:Event)=>e.target instanceof HTMLImageElement&&e.target.matches('[data-turntable]')?e.target:undefined;
 document.addEventListener('click',e=>{
  if(!(e.target instanceof Element)||!e.target.closest('#customize-tab-bar, #close-customize, #btn-customize'))return;
  for(const [image,state] of previews)if(image.id!=='momo-selected-portrait'){
   state.angle=0;state.hover=false;state.playing=false;state.paused=false;state.drawKey=undefined;state.canvas.dataset.angle='0';
  }
 });
 let drag:{image:HTMLImageElement;x:number;angle:number}|undefined;
 document.addEventListener('pointerover',e=>{const image=target(e);if(image)get(image).hover=true;});
 document.addEventListener('pointerout',e=>{const image=target(e);if(image){get(image).hover=false;get(image).paused=false;}});
 document.addEventListener('pointerdown',e=>{const image=target(e);if(!image)return;e.preventDefault();image.setPointerCapture(e.pointerId);drag={image,x:e.clientX,angle:get(image).angle};});
 document.addEventListener('pointermove',e=>{if(drag)get(drag.image).angle=wrap(drag.angle+(e.clientX-drag.x)/90);});
 document.addEventListener('pointerup',e=>{if(drag&&Math.abs(e.clientX-drag.x)<5){const state=get(drag.image),play=!state.playing;for(const other of previews.values())other.playing=false;state.playing=play;state.paused=!play;}drag=undefined;});
 document.addEventListener('pointercancel',()=>{drag=undefined;});
 document.addEventListener('keydown',e=>{const image=target(e);if(!image)return;const state=get(image);
  if(e.key===' '||e.key==='Enter'){e.preventDefault();state.playing=!state.playing;state.paused=!state.playing;}
  if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();state.angle=wrap(state.angle+(e.key==='ArrowRight'?.12:-.12));}
 });
 let previous=0;
 const tick=(now:number):void=>{
  requestAnimationFrame(tick);const dt=Math.min(.04,(now-previous)/1000);previous=now;if(document.hidden)return;
  const wardrobe=document.getElementById('customize-menu');
  for(const image of Array.from(document.querySelectorAll<HTMLImageElement>('img[data-turntable]'))){
   if(!image.offsetParent){const old=previews.get(image);if(old){old.canvas.style.display='none';old.hover=false;old.playing=false;old.paused=false;old.angle=0;old.drawKey=undefined;}continue;}
   const r=image.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)continue;
   const lobby=image.id==='momo-selected-portrait';
   const state=get(image),active=lobby?!wardrobe?.offsetParent:!state.paused&&(state.hover||state.playing);
   // Keep idle cards on their one small portrait. Download the other views
   // only for the selected lobby operator or a character being turned.
   if((active || drag?.image===image || state.angle!==0) && !state.views && !state.loading){
    const design=state.design;state.loading=true;
    if(!assets.has(design))assets.set(design,Promise.all(Array.from({length:8},async(_,i)=>{
     const frame=new Image();frame.decoding='async';frame.fetchPriority='low';frame.src=`/img/momo/skins-52/${design}-${i}.webp`;await frame.decode();return frame;
    })));
    void assets.get(design)!.then(views=>{if(state.design===design)state.views=views;}).catch(()=>{assets.delete(design);if(state.design===design)state.loading=false;});
   }
   if(active&&!reduced.matches&&drag?.image!==image)state.angle=wrap(state.angle+dt*.9);
   if(!state.views)continue;
   const ctx=state.canvas.getContext('2d')!;
   const css=getComputedStyle(image);
   Object.assign(state.canvas.style,{display:'block',left:`${image.offsetLeft}px`,top:`${image.offsetTop}px`,width:`${image.offsetWidth}px`,height:`${image.offsetHeight}px`,padding:css.padding});image.style.opacity='0';
   const frame=Math.round(state.angle)%8;
   const drawKey=`${state.design}:${frame}:${image.offsetWidth}:${image.offsetHeight}`;
   if(state.drawKey===drawKey)continue;state.drawKey=drawKey;
   state.canvas.dataset.angle=(state.angle*45).toFixed(2);
   ctx.clearRect(0,0,W,H);
   ctx.drawImage(state.views[frame],0,0);
  }
 };
 requestAnimationFrame(tick);
}
